import { createAction, props } from '@ngrx/store';

export const backgroundColorSet = createAction(
  '[Post Message] backgroundColor has been set for FullSite Branding',
  props<{ payload: { cssColor: string } }>()
);

export const resizeSitebar = createAction('[Post Message] resizeSitebar has been triggered');
export const resizeSitebar300 = createAction('[Post Message] resizeSitebar300 has been triggered');
export const defineSitebar = createAction('[Post Message] defineSitebar has been triggered');
